import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { FnTabComponent } from './fn-tab.component';

export * from './fn-tab.component';
export * from './fn-tab.model';

@NgModule({
    imports: [FormsModule, CommonModule, MatTabsModule],
    declarations: [FnTabComponent],
    exports: [FnTabComponent]
})
export class FnTabModule {

}
